// *https://www.registers.service.gov.uk/registers/country/use-the-api*
import fetch from "cross-fetch";
import React, { useEffect, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";


export default function MembersSearch(props) {
  const apiDomain=(process.env.NODE_ENV!=="development"?"/api":"http://"+window.location.hostname+":9000/api")
  const {idToken,customerSelected,setCustomerFromOutside}=props;
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [selectedMemberId, setSelectedMemberId] = React.useState();
  const [selectedMemberFullName, setSelectedMemberFullName] = React.useState(props.setCustomerFromOutside);
  const [selectedMemberEmail, setSelectedMemberEmail] = React.useState("");
  const [selectedMemberMobile, setSelectedMemberMobile] = React.useState("");

  const onChangeHandle = async value => { 
        setLoading(true);
        const resp=await fetch(apiDomain+"/members/search/"+encodeURIComponent(value),
        {"headers":{"id_token":idToken}});
        const members=await resp.json();
        setOptions(members);
        setLoading(false);
  };

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(()=>{
      console.log(`Member selected: ${selectedMemberFullName} (${selectedMemberId})`);
      customerSelected({customerId:selectedMemberId,fullName:selectedMemberFullName,email:selectedMemberEmail,mobile:selectedMemberMobile});
  },[selectedMemberId,selectedMemberFullName,selectedMemberMobile])

  useEffect(()=>{
    console.log("setting outside customer");
  },[setCustomerFromOutside])

  return (
    <>
    <Autocomplete
      fullWidth
      id="asynchronous-demo"
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionSelected={(option, value) => {
        return (option.fullName === value.fullName)
        }
    }
      getOptionLabel={option => option.fullName +' ('+option.mobile+')'}
      options={options}
      loading={loading}
      onChange={(event, value) => {
        document.activeElement.blur();
          if(value && value.contact_id){
            setSelectedMemberId(value.contact_id);
            setSelectedMemberFullName(value.fullName);
            setSelectedMemberEmail(value.email);
            setSelectedMemberMobile(value.mobile);
          }else{
            console.log("value:none")
            setSelectedMemberId("");
            setSelectedMemberFullName("");
            setSelectedMemberEmail("");
            setSelectedMemberMobile("");

          }
        }
        }
      renderInput={params => (
        <TextField
          {...params}
          label="Ονοματεπώνυμο Μέλους ή Τηλέφωνο"
          size="medium"
          onChange={ev => {
            // dont fire API if the user delete or not entered anything
            if (ev.target.value !== "" || ev.target.value !== null) {
              onChangeHandle(ev.target.value);
            }
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
            
          }}
        />
      )}
    />
    </>
  );
}